

window.initVideoIfMarketingCookiesAccepted = function (callback, callbackParam) {
  ppms.cm.api('getComplianceSettings', function (compliance) {
    if (compliance.consents.remarketing && compliance.consents.remarketing.status === 1) {
      callback(callbackParam);
    }
    else {
      window.addEventListener('CookieConsentGiven', () => initVideoIfMarketingCookiesAccepted(callback, callbackParam), { once: true });
    }
  });
}